import React, { Component, Fragment } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core';
import HUBContext from '../../../services/HUBContext';
import { Link, withRouter } from "react-router-dom";
import { Modal, Form, Button, Upload, Select, Table, Pagination, Tooltip, InputNumber as AntInputNumber } from 'antd';
import { DV3BackIcon, V3CheckSuccessCircleIcon, DV3UploadImage, V3FinesNotificationIcon, CheckIcon, V3ModalSuccessIcon  } from '../../../common/icons';
import { withAlert } from 'react-alert';
import moment from 'moment';
import hubAPI from '../../../services/hubAPI';
import { capitalize, orderBy } from 'lodash';
import handleAPI from "../../../helpers/handleAPI";
import LoadInWidget from '../../../helpers/loadInWidget';
import FineStatusTag from '../detail/FineStatusTag';
import FineModuleAdds from '../detail/FineModuleAdds';

const { Option } = Select;
const styles = theme => ({
    mainContainer: {
        backgroundColor: 'transparent !important',
        borderBottom: '0 !important'
    },
    cardStage: {
        padding: '24px !important',
        gap: '24px !important',

        '& .ant-form-explain': {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },

        '& > div': {
            width: '100%'
        },
        '& .stage': {
            display: 'flex',
            flexDirection: 'row',
            alignSelf: 'stretch',
            justifyContent: 'center',
            alignItems: 'baseline',
            gap: '0px',

            '& button': {
                display: 'flex',
                width: '60px',
                height: '60px',
                padding: '4px 8px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '16px',
                flexShrink: 0,
                position: 'relative',

                borderRadius: '78px',
                border: '1px solid var(--edenred-primary-default-red, #F72717)',
                background: 'var(--edenred-primary-default-red, #F72717)',

                '& > div.stage-payload': {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px',
                    flex: '1 0 0',
                    '& svg':{
                        height: '14px'
                    }
                },
                '& .completed': {
                    display: 'none',
                    position: 'absolute',
                    right: '0.5px',
                    top: '0.5px',
                    width: '24px',
                    height: '24px',
                    padding: '4px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '8px'
                },
                '& .stage-payload-text': {
                    color: 'var(--system-white, #FFF)',
                    fontFamily: 'Ubuntu',
                    fontSize: '15px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal'
                },
                '& .tag': {
                    display: 'flex',
                    padding: '2px 8px',
                    alignItems: 'center',
                    gap: '4px',
                    position: 'absolute',
                    bottom: '4px',
                    borderRadius: '50px',
                    background: 'var(--warning-alert-alert-10, #FFFAEB)',
                    color: 'var(--warning-alert-alert, #FAC83B)',
                    fontFamily: 'Ubuntu',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal',

                    '&.red': {
                        color: 'var(--warning-urgent-urgent, #FF5978);',
                        background: 'var(--warning-urgent-urgent-10, #FFEEF2)'
                    }
                }
            },
            '& button.success': {
                border: '1px solid #00A184',

                '& .completed': {
                    display: 'flex',
                },
                '& .stage-payload-icon': {
                    '& svg': {
                        '& path': {
                            stroke: '#00A184'
                        }
                    }
                },
                '& .stage-payload-text': {
                    color: '#00A184'
                }
            },
            '& button:disabled': {
                display: 'flex',
                cursor: 'default',
                border: '1px solid var(--type-and-elements-medium-light, #D3D6DB)',

                '& .stage-payload-icon': {
                    '& svg': {
                        '& path': {
                            stroke: 'var(--type-and-elements-medium-light, #D3D6DB)'
                        }
                    }
                },
                '& .stage-payload-text': {
                    color: 'var(--type-and-elements-medium-light, #D3D6DB)'
                }
            },
            '& .connector': {
                alignSelf: 'baseline',
                marginTop: '50px',
                height: '2px',
                width: '200px',
                backgroundColor: 'var(--edenred-primary-default-red, #F72717);'
            }
        },
        '& .form-field-row': {
            display: 'flex',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            gap: '24px',

            '& .ant-form-item': {
                marginBottom: '0px',
                padding: '0px',
                minWidth: '350px',

                '& .ant-form-item-label': {
                    color: 'var(--type-and-elements-dark, #33323D)',
                    fontFamily: 'Ubuntu',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px'
                },

                '& .ant-calendar-picker': { minWidth: '350px' },
                '& .ant-time-picker': { minWidth: '350px' },
                
                '& .ant-form-item-required::before': {
                    display: 'none'
                },
                '& .ant-form-item-required::after': {
                    display: 'inline-block',
                    marginRight: '4px',
                    color: '#f5222d',
                    fontSize: '14px',
                    fontFamily: 'SimSun, sans-serif',
                    lineHeight: 1,
                    content: '"*"'
                }
            }
        }
    },
    fineUploadPro:{
        width: '100%',
        backgroundColor: 'var(--warning-newness-newness-10, #E7F3FF)',
        height: '60px'
    },
    containerUploadFile:{
        border: '2px dashed var(--type-and-elements-medium-light, #D3D6DB)', 
        padding: '20px',
        backgroundColor : 'var(--system-background-light, #f8f8f8)'
    },
    containerUploadFileText:{
        maxWidth: '100% !important',
        textAlign: 'center !important',
        fontSize: '14px',
        fontStyle: 'normal',
        fontFamily: 'Ubuntu',
        fontWeight: 400,
        lineHeight: '1'
    },
    checkIcon: {
        marginRight: '8px',
        '& path': {
            fill: '#00A184'
        }
    },
    errorIcon: {
        marginRight: '8px',
        width: '12px',
        height: '12px',
        '& path': {
            fill: 'red'
        }
    },
    uploadFooter:{
        marginTop: '12px'
    },
    uploadValidationFooter:{
        marginTop: '10px !important',
        display: 'flex !important',
        justifyContent: 'space-between !important'
    },
    stageValidation:{
        backgroundColor: 'var(--type-and-elements-medium-light, #D3D6DB) !important',
        border: '1px solid var(--type-and-elements-medium-light, #D3D6DB) !important'
    },
    table:{'& .ant-table-thead > tr > th':{

        background:'var(--edenred-primary-default-red, #F72717) !important'
    },
    '& .anticon svg':{

        fill: 'var(--system-white, #FFF) !important'
    }

    },
    backTabClass:{
        '& .v3-button > svg > path': {

            fill:'#F72717 !important'

        }
    },
    cuztomizeSuccess: {
        '& .ant-modal-confirm-btns': {
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0px',
            gap: '16px',
            flex: 'none',
            flexGrow: 0,
            '& .v3-button': {
                margin: '0px !important',
				width: '120px'
            }
        }
    },

    containerButtonLeft:{
        maxWidth: '60px',
        display: 'flex',
        flexDirection: 'column',
        '& button':{
            float: 'right'
        },
        '& span': {
            fontSize: '12px',
            fontFamily: 'Ubuntu',
            fontWeight: '500',
            color: 'var(--edenred-primary-default-red, #F72717)'
        }
    },
    containerButtonRight:{
        maxWidth: '97px',
        display: 'flex',
        flexDirection: 'column',
        '& button':{
            float: 'left'
        },
        '& span': {
            fontSize: '12px',
            fontFamily: 'Ubuntu',
            fontWeight: '500'
        }
    },
    successContentModal: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        padding: '0px',

        '& > div': {
            gap: '16px'
        }
    }
    
});

const { Dragger } = Upload;
const RemoveIcon = (props) => <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M8.12442 0.00834451C6.81991 0.0694261 5.57653 0.437503 4.45082 1.09584C3.45991 1.67535 2.58577 2.48495 1.92169 3.43825C1.59578 3.9061 1.30606 4.43948 1.08836 4.97241C0.780967 5.72493 0.594542 6.49648 0.525031 7.30385C0.502702 7.56328 0.498887 7.66526 0.498945 8.00145C0.499009 8.38243 0.508558 8.57205 0.543892 8.89425C0.713294 10.4387 1.34525 11.9209 2.3447 13.1178C2.50454 13.3092 2.62874 13.444 2.84093 13.6561C3.05324 13.8685 3.18815 13.9928 3.37931 14.1524C4.63132 15.1974 6.18929 15.8377 7.80762 15.9721C8.07666 15.9944 8.16799 15.9978 8.49562 15.9978C8.82326 15.9978 8.91459 15.9944 9.18362 15.9721C10.8018 15.8377 12.3601 15.1973 13.6119 14.1524C13.8025 13.9933 13.9378 13.8686 14.1503 13.6561C14.3626 13.4437 14.4872 13.3086 14.6465 13.1178C15.6458 11.9212 16.2786 10.437 16.4473 8.89425C16.4696 8.69021 16.4892 8.41812 16.4892 8.31063C16.4892 8.27408 16.492 8.24367 16.4956 8.24145C16.4997 8.23892 16.502 8.14816 16.5019 7.98987C16.5019 7.82763 16.4997 7.74556 16.4956 7.75185C16.4914 7.75839 16.4894 7.74001 16.4893 7.69425C16.4891 7.58397 16.4697 7.31313 16.4473 7.10865C16.2778 5.55885 15.637 4.06049 14.6341 2.86865C13.7353 1.80059 12.618 1.00648 11.3199 0.513093C10.6082 0.242597 9.85347 0.0770869 9.07482 0.0207477C8.81377 0.00186131 8.383 -0.00376429 8.12442 0.00834451ZM8.31002 1.00368C7.2291 1.03715 6.24336 1.28974 5.29242 1.77693C4.64106 2.11064 4.08217 2.51977 3.54806 3.05389C3.00497 3.59697 2.58946 4.1685 2.24962 4.83985C1.64849 6.02739 1.40325 7.33748 1.52961 8.68625C1.65051 9.9767 2.15332 11.2437 2.95569 12.2799C3.25896 12.6715 3.63533 13.0607 4.02571 13.3865C4.56504 13.8366 5.14931 14.1897 5.81132 14.4656C6.47671 14.743 7.17047 14.9125 7.89082 14.9739C8.2635 15.0056 8.72775 15.0056 9.10042 14.9739C10.1601 14.8836 11.1816 14.5527 12.1011 14.0019C12.7577 13.6086 13.3712 13.0813 13.877 12.4757C14.7817 11.3925 15.339 10.049 15.4648 8.64785C15.4857 8.41396 15.4922 8.26254 15.4921 8.00145C15.4921 7.60203 15.4681 7.28047 15.4102 6.90705C15.2703 6.00384 14.9338 5.09843 14.4455 4.31185C14.1596 3.85119 13.8424 3.45312 13.4432 3.05389C13.019 2.62973 12.5828 2.28752 12.0956 1.99668C11.1135 1.41042 10.0307 1.0776 8.89562 1.01311C8.77059 1.006 8.41822 1.00033 8.31002 1.00368ZM5.44602 4.4727C5.43546 4.47433 5.41114 4.48009 5.39196 4.4855C5.22585 4.53239 5.02254 4.73797 4.97823 4.90385C4.96358 4.95871 4.96364 5.04865 4.97834 5.09872C4.99171 5.14426 5.01928 5.20028 5.05411 5.25265C5.07079 5.27775 5.54881 5.76052 6.43399 6.64626L7.78835 8.00148L6.43718 9.35346C5.69404 10.0971 5.07471 10.7213 5.0609 10.7407C4.99292 10.8359 4.96746 10.9066 4.96744 10.9999C4.96744 11.0515 4.97066 11.0737 4.98413 11.1151C5.03617 11.2746 5.21472 11.4543 5.37689 11.5102C5.42195 11.5257 5.44233 11.5291 5.49013 11.5292C5.58427 11.5293 5.65745 11.5042 5.75002 11.4398C5.77674 11.4213 6.27544 10.9274 7.14362 10.0598L8.49562 8.70872L9.84762 10.0598C10.7158 10.9274 11.2145 11.4213 11.2412 11.4398C11.3338 11.5042 11.407 11.5293 11.5011 11.5292C11.5489 11.5291 11.5693 11.5257 11.6144 11.5102C11.7765 11.4543 11.9551 11.2746 12.0071 11.1151C12.0206 11.0737 12.0238 11.0515 12.0238 10.9999C12.0238 10.9066 11.9983 10.8359 11.9303 10.7407C11.9165 10.7213 11.2972 10.0971 10.5541 9.35346L9.20289 8.00148L10.5573 6.64626C11.4828 5.72013 11.9201 5.27827 11.9385 5.25067C12.0761 5.04416 12.0493 4.85142 11.8556 4.654C11.658 4.45252 11.4605 4.41762 11.2595 4.54864C11.222 4.57311 10.9369 4.8547 9.85402 5.93675L8.49561 7.29417L7.14042 5.94001C6.39506 5.19522 5.77082 4.57583 5.75322 4.56357C5.70063 4.52695 5.66492 4.50847 5.61316 4.4911C5.56493 4.4749 5.48725 4.46636 5.44602 4.4727ZM0.498535 7.99825C0.498535 8.13553 0.49938 8.19078 0.500417 8.12103C0.501454 8.05128 0.501447 7.93896 0.50041 7.87143C0.49938 7.8039 0.498529 7.86097 0.498535 7.99825Z" fill="white"/>
</svg>

const CompleteIcon = (props) => <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.687 0.140547C11.5254 0.0245871 11.3243 -0.0223735 11.1281 0.00999493C10.9318 0.0423634 10.7564 0.15141 10.6405 0.313147L3.62305 10.1028L1.28056 7.75697C1.21093 7.68726 1.12825 7.63196 1.03726 7.59423C0.946268 7.55649 0.848738 7.53705 0.750239 7.53703C0.651739 7.53701 0.554199 7.5564 0.463189 7.59409C0.372178 7.63178 0.289479 7.68705 0.219813 7.75672C0.150147 7.82639 0.0948783 7.90912 0.0571627 8.00016C0.0194471 8.09121 2.32342e-05 8.1888 2.08312e-08 8.28735C-2.31925e-05 8.38591 0.0193547 8.48351 0.0570274 8.57457C0.0947001 8.66563 0.14993 8.74838 0.219563 8.81809L3.18706 11.7868C3.26497 11.8618 3.35793 11.9194 3.45977 11.9557C3.56162 11.992 3.67002 12.0063 3.77778 11.9975C3.88555 11.9887 3.99021 11.957 4.08482 11.9047C4.17943 11.8523 4.26183 11.7804 4.32655 11.6938L11.8595 1.18766C11.9754 1.02591 12.0224 0.824725 11.99 0.628356C11.9577 0.431987 11.8487 0.256518 11.687 0.140547Z" fill="white"/>
</svg>

export class UploadFineForm extends Component {
    columnsSet = [];

    state = {
        companyID: 0,
        response: {},
        status: { loading: false, ready: true },
        shortDateFormats: 'YYYY-MM-DD',
        completedStages: [],
        disabledStages: [],
        stage: 'upload',
        selectedFile: null,
        allowedFileTypes: [".xls", ".xlsx"],
        currentFiles: [],
        pagination: {
            pageSize: 10,
            pageIndex: 0,
            count: 0
        }
    }

    componentDidMount() {
        const { match: { params }, intl } = this.props;
        const { company, setCompanyID, setCurrentDashboard, locale } = this.context;

        if (!locale) locale = 'en-US';
        let language = locale.substring(0, 2);

        if (language !== 'en')
            import(`moment/locale/${language}.js`)
                .then(() => { 
                    moment.locale(language); 
                    this.setState({ shortDateFormats: moment().localeData()._longDateFormat['L'] || 'YYYY-MM-DD' })
                });
         /*#waiting for integration of changes*/
        //Remove the current dashboard (por si esta cargado)
        setCurrentDashboard(null, intl, () => {
            if (!!document.body.classList.contains('dash-v2'))
                document.body.classList.remove('dash-v2');

            if (!document.body.classList.contains('dash-v3'))
                document.body.classList.add('dash-v3');

            if (!document.body.classList.contains('no-db-body-padding'))
                document.body.classList.add('no-db-body-padding');
        });

        this.setState({ companyID: company?.companyID || 0 }, () => { 

            this.prepareColumnSet();
        })
    }

    componentDidUpdate() {
        const { match: { params }, intl } = this.props;
        const { company, setCompanyID, setBreadCrumb } = this.context;
        const { companyID } = this.state;

        const inUrlCompanyID = isNaN(params.cid) ? 0 : parseInt(params.cid)
        if (!!company) {
            if (inUrlCompanyID !== company.companyID)
                setCompanyID(inUrlCompanyID)

            else if (company.companyID !== companyID)
            this.setState({ companyID: company.companyID }, () => {
                    //this.getData();
                    
                    let breadcrumb = [
                        { type: 'link', text: this.props.intl.formatMessage({ id: 'home', defaultMessage: 'Home' }), to: `/app/${company.companyID}` },
                        { type: 'selector' },
                        { type: 'title', text: intl.formatMessage({ id: 'fines.upload', defaultMessage: 'Fines upload' }) }
                    ];
                    setBreadCrumb(breadcrumb)
                })
        }
    }

    componentWillUnmount() {

        if (document.body.classList.contains('dash-v3'))
            document.body.classList.remove('dash-v3');

        if (document.body.classList.contains('no-db-body-padding'))
            document.body.classList.remove('no-db-body-padding');
    }

    onButtonClick = stage => {
        const { disabledStages, fine } = this.state;
        const { history } = this.props;
        const { company } = this.context;

        this.setState({
            stage: stage
        });
    }

    onNext = () => {
        const { currentFiles, status } = this.state;
        const { locale, company } = this.context;
        const { intl, alert } = this.props;
        
        var formData = new FormData();
        formData.append("file", currentFiles[0]);

        this.setState({ status: {...status, loading: true, sendingFile: true, results: null } });

        hubAPI.post(`api/v1/Company/${company?.companyID || 0}/finefileupload?culture=${locale || 'en-US'}`,
            formData,
            { 
                headers: { 'Content-Type': 'multipart/form-data' },
                onDownloadProgress: progressEvent => {
                    const { loaded, total } = progressEvent;
                    this.setState({ readingProgress: (total || 0) > 0 ? (loaded || 0) / total : 0 });
                },
                onUploadProgress: progressEvent => {
                    const { loaded, total } = progressEvent;
                    this.setState({ sendingProgress: (total || 0) > 0 ? (loaded || 0) / total : 0 });
                }
            })
            .then(response => {
                const { status, pagination } = this.state;

                // const vs = vehicleStatuses.map(x => ({ ...x, vehicleStatusID: x.id, name: intl.formatMessage({ id: `vehicles.vehicleStatusID.${x.id}`, defaultMessage: x.name }) }));
                // response.data.data.forEach((d, i) => {
                //     d.key = `key-${i}`;
                //     d.vehicleStatus = vs.find(x => x.vehicleStatusID === (d.vehicleStatusID || 0));
                // });

                let results = response.data.results || {};
                results.companyUploadID = results?.companyUploadID || 0;
                results.success = results?.success === 'true';

                if(results.success == true){
                    this.setState({ stage: 'validation' });
                }

                response.data.data = orderBy(response.data.data, ['__hasError'], ['desc']);
                this.setState({
                    results,
                    response: response.data,
                    activePanelKey: ['preview'],
                    status: {...status, loading: false, sendingFile: false }, 
                    pagination: {...pagination, count: response.data.data.length, pageIndex: 0 }
                });
            })
            .catch(error => {
                this.setState({ status: {...status, loading: false, sendingFile: false } });
                handleAPI(error, alert, intl);
            });

    }

    onApply = () => {
        const { currentFiles, status, response, results } = this.state;
        const { locale, company, dashboards } = this.context;
        const { intl, alert, history, classes } = this.props;

        if (!!status.applying) return;
        if ((response?.data || []).length <= 0) return;
        if (!results?.success) return;
        if ((results?.companyUploadID || 0) <= 0) return;
        const hasError = (response?.data || []).some(x => !!x.__hasError);
        if (hasError) return;

        let fineDashboardID = (dashboards || []).find(x => x.dashboardKey === 'fines-v1')?.dashboardID || 0;
        
        this.setState({ status: {...status, loading: true, applying: true } });
        
        const type = 'fines-main';

        const postObject = {
            companyUploadID: results?.companyUploadID || 0,
            type: type
        }

        hubAPI.post(`api/v1/Company/${company?.companyID || 0}/finefileuploaddata?culture=${locale || 'en-US'}`, postObject)
        .then(_ => { 
            this.setState({ status: {...status, loading: false, applying: false, results: null } }, () => {
                //history.push(`/app/${company?.companyID || 0}/dash/${fineDashboardID}`);
                Modal.success({
                    icon: null,
                    title: '',
                    width: '420px',
                    className: `modal-success ${classes.cuztomizeSuccess}`,
                    okButtonProps:{className: 'v3-button primary'},
                    okText: intl.formatMessage({ id: 'gotIt', defaultMessage: 'Close' }),
                    content: <div className={classes.successContentModal}>
                            <img src={`/img/fine-creation-success.png`} alt={intl.formatMessage({ id: 'fines.Notification', defaultMessage: 'Notification' })}/>
                            <div>
                                <h1>{intl.formatMessage({ id: 'fines.upload.success', defaultMessage: 'Upload concluded!' })}</h1>
                                <span>{intl.formatMessage({ id: 'fines.upload.successInfo', defaultMessage: 'Fines are already available on the portal.' })}</span>
                            </div>
                        </div>,
                    onOk: () => {
                        history.push(`/app/${company?.companyID || 0}/dash/${fineDashboardID}`);
                    }
                });
            });
        })



    }

    onRemoveFile = (e) => {
        e.stopPropagation();
        this.setState({ currentFiles: [] });
    }

    renderValidationsTable = (columnName, record) => {
        const { intl, classes } = this.props;

        const errorcolumn = record?.["__errors_" + columnName];
        const errorCount = errorcolumn?.length || 0;

        const tooltipTitle = <ul style={{listStyleType: 'none'}}>
                        {(errorcolumn || []).map((x, i) => <li key={i}>{x}</li>)}
                    </ul>;
                    const valueColumn = record?.[columnName];

                    return <span>
                        { errorCount <= 0 && valueColumn }
                        {
                            errorCount > 0 && (<div>
                                <Tooltip placement="top" title={tooltipTitle}>
                                    <RemoveIcon className={classes.errorIcon} />
                                </Tooltip>{valueColumn}
                                </div>)
                        }
                    </span>
    }

    prepareColumnSet() {

        const { intl, classes } = this.props;

        this.columnsSet = [
            {
                dataIndex: '__hasError',
                title: '',
                width: 60,
                render: (_, record) => {
                    const tooltipTitle = <ul style={{listStyleType: 'none'}}>
                        {(record?.__errors || []).map((x, i) => <li key={i}>{x}</li>)}
                    </ul>;
                    return <span>
                        { !record?.__hasError && <CompleteIcon className={classes.checkIcon} />}
                        {
                            !!record?.__hasError && <Tooltip placement="top" title={tooltipTitle}>
                                <RemoveIcon className={classes.errorIcon} />
                            </Tooltip>
                        }
                    </span>
                }
            },
            {
                dataIndex: 'reference',
                title: intl.formatMessage({id: 'fines.uploadTable.fineNumber', defaultMessage:'Infraction number (AIT)' }),
                sorter: true,
                width: 170,
                render: (_, record) => this.renderValidationsTable('reference',record)
            },
            {
                dataIndex: 'sourceReference',
                title: intl.formatMessage({id: 'fines.uploadTable.originalFineID', defaultMessage:'Original infraction number (AIT)' }),
                sorter: true,
                width: 270
            },
            {
                dataIndex: 'fineStageID',
                title: intl.formatMessage({id: 'fines.uploadTable.status', defaultMessage:'Status' }),
                sorter: true,
                width: 170,
                render: (_, record) => {
                    return <FineStatusTag fine={record} />
                }
            },
            {
                dataIndex: 'lawArticle',
                title: intl.formatMessage({id: 'fines.uploadTable.framework', defaultMessage:'Framework' }),
                sorter: true,
                width: 170,
                render: (_, record) => this.renderValidationsTable('lawArticle',record)
            },
            {
                dataIndex: 'lawDescription',
                title: intl.formatMessage({id: 'fines.uploadTable.lawDescription', defaultMessage:'Law description' }),
                sorter: true,
                width: 230,
                render: (_, record) => this.renderValidationsTable('lawDescription',record)
            },
            {
                dataIndex: 'type',
                title: intl.formatMessage({id: 'fines.uploadTable.type', defaultMessage:'Type' }),
                sorter: true,
                width: 170
            },
            {
                dataIndex: 'vehiclePlate',
                title: intl.formatMessage({id: 'fines.uploadTable.plate', defaultMessage:'Plate' }),
                sorter: true,
                width: 170,
                render: (_, record) => this.renderValidationsTable('vehiclePlate',record)
            },
            {
                dataIndex: 'dateFine',
                title: intl.formatMessage({id: 'fines.uploadTable.infractionDate', defaultMessage:'Infraction date' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('dateFine',record)
            },
            {
                dataIndex: 'timeFine',
                title: intl.formatMessage({id: 'fines.uploadTable.infractionTime', defaultMessage:'Infraction time' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('timeFine',record)
            },
            {
                dataIndex: 'dateDriverIndicationDue',
                title: intl.formatMessage({id: 'fines.uploadTable.indicationDeadline', defaultMessage:'Indication deadline' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('dateDriverIndicationDue',record)
            },
            {
                dataIndex: 'amountBase',
                title: intl.formatMessage({id: 'fines.uploadTable.originalValue', defaultMessage:'Value' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('amountBase',record)
            },
            {
                dataIndex: 'merchantName',
                title: intl.formatMessage({id: 'fines.uploadTable.authorizingBody', defaultMessage:'Authorizing body' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('merchantName',record)
            },
            {
                dataIndex: 'customAddress',
                title: intl.formatMessage({id: 'fines.uploadTable.infractionLocation', defaultMessage:'Address' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('customAddress',record)
            },
            {
                dataIndex: 'fineSeverityCode',
                title: intl.formatMessage({id: 'fines.uploadTable.fineSeverity', defaultMessage:'Severity' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('fineSeverityCode',record)
            },
            {
                dataIndex: 'points',
                title: intl.formatMessage({id: 'fines.uploadTable.finePointing', defaultMessage:'Points' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('points',record)
            },
            {
                dataIndex: 'dateNotificationSent',
                title: intl.formatMessage({id: 'fines.uploadTable.notificationReceiptDate', defaultMessage:'Notification receipt date' }),
                sorter: true,
                width: 270,   
                render: (_, record) => this.renderValidationsTable('dateNotificationSent',record)
            },
            {
                dataIndex: 'timeNotificationSent',
                title: intl.formatMessage({id: 'fines.uploadTable.notificationReceiptTime', defaultMessage:'Notification receipt time' }),
                sorter: true,
                width: 270,   
                render: (_, record) => this.renderValidationsTable('timeNotificationSent',record)
            },
            {
                dataIndex: 'driverLegalIdentification',
                title: intl.formatMessage({id: 'fines.uploadTable.fineIdentifiedDriver', defaultMessage:'Driver' }),
                sorter: true,
                width: 340,   
                render: (_, record) => this.renderValidationsTable('driverLegalIdentification',record)
            },
            {
                dataIndex: 'dateDriverAssignment',
                title: intl.formatMessage({id: 'fines.uploadTable.driverAssigmentDate', defaultMessage:'Driver assigment date' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('dateDriverAssignment',record)
            },
            {
                dataIndex: 'dateDriverIndicationSend',
                title: intl.formatMessage({id: 'fines.uploadTable.driverIndicationDate', defaultMessage:'Driver indication date' }),
                sorter: true,
                width: 170,   
                render: (_, record) => this.renderValidationsTable('dateDriverIndicationSend',record)
            },
            {
                dataIndex: 'indicationTrackingID',
                title: intl.formatMessage({id: 'fines.uploadTable.indicationTracking', defaultMessage:'Indication tracking' }),
                sorter: true,
                width: 170,   
            },

            {
                dataIndex: 'appealDate',
                title: intl.formatMessage({id: 'fines.uploadTable.appealStartDate', defaultMessage:'Appeal start date' }),
                sorter: true,
                width: 200,   
                render: (_, record) => this.renderValidationsTable('appealDate',record)
            },
            {
                dataIndex: 'appealStatus',
                title: intl.formatMessage({id: 'fines.uploadTable.appealStatus', defaultMessage:'Appeal status' }),
                sorter: true,
                width: 200,   
                render: (_, record) => this.renderValidationsTable('appealStatus',record)
            },
            {
                dataIndex: 'installmentDate',
                title: intl.formatMessage({id: 'fines.uploadTable.installmentDate', defaultMessage:'Installment date' }),
                sorter: true,
                width: 200,   
                render: (_, record) => this.renderValidationsTable('installmentDate',record)
            },
            {
                dataIndex: 'refundDate',
                title: intl.formatMessage({id: 'fines.uploadTable.refundDate', defaultMessage:'Refund date' }),
                sorter: true,
                width: 200,   
                render: (_, record) => this.renderValidationsTable('refundDate',record)
            },
            {
                dataIndex: 'dateDriverIndicationArrive',
                title: intl.formatMessage({id: 'fines.uploadTable.dateDriverIndicationArrive', defaultMessage:'Date driver indication arrive' }),
                sorter: true,
                width: 250,   
                render: (_, record) => this.renderValidationsTable('dateDriverIndicationArrive',record)
            },
            {
                dataIndex: 'timeDriverIndicationArrive',
                title: intl.formatMessage({id: 'fines.uploadTable.timeDriverIndicationArrive', defaultMessage:'Time driver indication arrive' }),
                sorter: true,
                width: 250,   
                render: (_, record) => this.renderValidationsTable('timeDriverIndicationArrive',record)
            },
            {
                dataIndex: 'paymentDate',
                title: intl.formatMessage({id: 'fines.uploadTable.finePaymentDate', defaultMessage:'Payment date' }),
                sorter: true,
                width: 250,   
                render: (_, record) => this.renderValidationsTable('paymentDate',record)
            },
            {
                dataIndex: 'amountPaid',
                title: intl.formatMessage({id: 'fines.uploadTable.finesAmountPaid', defaultMessage:'Amount paid' }),
                sorter: true,
                width: 200,   
                render: (_, record) => this.renderValidationsTable('amountPaid',record)
            }
        ];
    }

    render() {
        const { classes, intl, form, location } = this.props;
        const { stage, currentFiles, status, readingProgress, sendingProgress, pagination, results, response } = this.state;
        const { company, dashboards, locale } = this.context;

        let finesDashboardID = (dashboards || []).find(x => x.dashboardKey === 'fines-v1')?.dashboardID || 0;
        if (finesDashboardID <= 0)
            finesDashboardID = (dashboards || []).find(x => x.dashboardKey === 'home')?.dashboardID || 0;

        let URLBack = `/app/${company?.companyID || 0}/dash/${finesDashboardID}`;

        const _this = this;
        const uploadProps = {
            name : 'file',
            multiple : false,
            showUploadList: false,
            beforeUpload: () => false,
            accept: "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            onChange(info) {
                const status = info.file.status;
                switch(status) {
                    case 'uploading':
                        console.log('uploading');
                        break;

                    case 'done':
                        console.log('done');
                        break;

                    case 'error':
                        console.log('error');
                        break;

                    default:
                        _this.setState({ currentFiles: [info.file] });
                }
            },
            onDrop(e) {
                console.log('Dropped files', e.dataTransfer.files);
            }
        }

        const hasError = (response?.data || []).some(x => !!x.__hasError);
        const rowNumber = response?.data?.length || 0;
        
        return <Fragment>
            <div className={`crud-details ${classes.mainContainer}`}>
                <div className='details'>
                    <div className='dashboard-area-back'>
                        <Link className='v3-button secondary' to={URLBack}>
                            <DV3BackIcon />
                            <FormattedMessage id='fines.goBack' defaultMessage='Go back' />
                        </Link>
                    </div>

                    <span className='page-title'><FormattedMessage id="fines.upload" defaultMessage='Fines upload' /></span>
                </div>
            </div>

            <Form layout={'vertical'}  className='crud-content'>
                <div className={`card ${classes.cardStage}`}>
                    <div className='stage'>
                        <div className={classes.containerButtonLeft}>
                            <button
                                // onClick={() => this.onButtonClick('upload')}
                                // className={completedStages.indexOf('notify') >= 0 ? 'success' : ''}
                                >
                                    {
                                        stage == 'upload' && <div className='stage-payload'>
                                        <span className='stage-payload-text'>1</span>
                                        </div>
                                    }
                                
                                    {
                                        stage !== 'upload' && <div className='stage-payload'>
                                        <CheckIcon stroke={'#FFFFFF'} />
                                        </div>
                                    }
                            </button>
                            <span><FormattedMessage id='fines.upload.fileSelect' defaultMessage='Select file' /></span>
                        </div>
                        <div className='connector' style={stage !== 'validation' ? {backgroundColor: 'var(--type-and-elements-medium-light, #D3D6DB)'}: {}} />
                        <div className={classes.containerButtonRight}>
                            <button 
                                // onClick={() => this.onButtonClick('validation')}
                                className={ stage !== 'validation' ? classes.stageValidation : ''}
                                >
                                    {
                                        stage !== 'validation' && 
                                        <div className={['stage-payload'].join(" ")} >
                                            <span className='stage-payload-text'>2</span>
                                        </div>
                                    }
                                    {
                                        stage == 'validation' && 
                                        <div className='stage-payload'>
                                            <span className='stage-payload-text'>2</span>
                                        </div>
                                    }
                            </button>
                            <span style={{marginLeft:'-30px'}}><FormattedMessage id='fines.upload.previewUpload' defaultMessage='Preview upload' /></span>
                        </div>
                        
                    </div>
                    <hr style={{width: '100%', borderTop: '1px solid var(--type-and-elements-medium-light, #D3D6DB)'}}></hr>

                    <div style={{width: '100%'}}>
                        <div style={(stage !== 'upload' ? { display: 'none' } : {} )}>
                            <FineModuleAdds>
                                Com a versão <b>PRO</b> você recebe notificações de infrações de forma automática e digital.
                            </FineModuleAdds>
                            <div className={`uploadContainer`}>
                                <Dragger {...uploadProps}>
                                    <div className="ant-upload-drag-icon"><DV3UploadImage /></div>
                                    <p className='ant-upload-text'><FormattedMessage id='fines.uploadTextInput' defaultMessage='Click here to upload file' /></p>
                                    <span className={classes.fileFormat}><FormattedMessage id='vehicles.upload.DraggerText2' defaultMessage='.xlsx file extension allowed' /></span>

                                    {
                                        (currentFiles || []).map((x, i) => <span key={i} className={`v3-tag default file-tag`}>
                                                {x.name || `File ${i}`}
                                                <span className='remove-tag' onClick={this.onRemoveFile}>
                                                    <RemoveIcon />
                                                </span>
                                            </span>)
                                    }
                                </Dragger>
                            </div>

                            {/* {  [ 'tagContainer', classes.tagContainer, classStyle ].join(" ")  } */}
                            <hr style={{width: '100%', marginTop:'12px', borderTop: '1px solid var(--type-and-elements-medium-light, #D3D6DB)'}}></hr>

                            <div className={['footer-card', classes.uploadFooter].join(" ")}>
                                <Button
                                    loading={status.sendingFile}
                                    onClick={this.onNext}
                                    disabled={currentFiles.length <= 0}
                                    className='v3-button primary'
                                    style={{ minWidth: status.sendingFile ? '170px' : undefined }}>
                                    { !status.sendingFile && <FormattedMessage id='next' defaultMessage='Next' />}
                                    { !!status.sendingFile && sendingProgress > 0 && sendingProgress < 1 && `${capitalize(intl.formatMessage({ id: 'preparing', defaultMessage: 'preparing...' }))} ${(sendingProgress > 0 ? intl.formatNumber(sendingProgress, { style: 'percent' }) : '')}` }
                                    { !!status.sendingFile && (sendingProgress <= 0 || sendingProgress >= 1) && `${capitalize(intl.formatMessage({ id: 'reading', defaultMessage: 'reading...' }))} ${(readingProgress > 0 ? intl.formatNumber(readingProgress, { style: 'percent' }) : '')}` }
                                </Button>
                            </div>



                        </div>
                        <div style={(stage !== 'validation' ? { display: 'none' } : {} )}>
                        {/* <div> */}
                            <div className='table-area'>
                                <Table
                                    className={classes.table}
                                    pagination={false}
                                    scroll={{ x: 500 }}
                                    dataSource={(response?.data || []).slice(pagination.pageIndex * pagination.pageSize, (pagination.pageIndex * pagination.pageSize) + pagination.pageSize)}
                                    columns={this.columnsSet} />

                                <div className='pagination-section'>
                                    <div className='pagination-section-left'>
                                        <Pagination
                                            showSizeChanger
                                            current={(pagination?.pageIndex || 0) + 1}
                                            pageSize={pagination?.pageSize || 10}
                                            total={pagination?.count || 0}
                                            pageSizeOptions={['10', '20', '30', '40', '50']}
                                            onChange={(current) => this.setState({ pagination: {...pagination, pageIndex: (current > 0 ? current - 1 : 0) }})}
                                            onShowSizeChange={(_, size) => this.setState({ pagination: {...pagination, pageSize: size, pageIndex: 0 }})} />
                                            
                                        <span className="pagerInfo">
                                            <FormattedMessage
                                                id="pagerInfo"
                                                defaultMessage="{0} - {1}, of {2} records."
                                                values={[
                                                    ((pagination?.pageIndex || 0) * (pagination?.pageSize || 10)) + 1,
                                                    (((pagination?.pageIndex || 0) + 1) * (pagination?.pageSize || 10)) > (pagination?.count || 0) ? (pagination?.count || 0) : (((pagination?.pageIndex || 0) + 1) * (pagination?.pageSize || 10)),
                                                    (pagination?.count || 0)]} />
                                        </span>
                                    </div>
                                    <div className='pagination-section-right'>
                                        <Pagination
                                            current={(pagination?.pageIndex || 0) + 1}
                                            pageSize={pagination?.pageSize || 5}
                                            total={pagination?.count || 0}
                                            pageSizeOptions={['10', '20', '30', '40', '50']}
                                            itemRender={this.paginationItemRender}
                                            onChange={(current) => this.setState({ pagination: {...pagination, pageIndex: (current > 0 ? current - 1 : 0) }})}
                                            onShowSizeChange={(_, size) => this.setState({ pagination: {...pagination, pageSize: size, pageIndex: 0 }})} />
                                    </div>
                                </div>

                                <hr style={{width: '100%', borderTop: '1px solid var(--type-and-elements-medium-light, #D3D6DB)'}}></hr>

                                <div className={['footer-card', classes.uploadValidationFooter].join(" ")}>
                                    <div className={['dashboard-area-back',classes.backTabClass].join(" ")}>
                                        <Link className={['v3-button secondary'].join(" ")} 
                                            to={'#'}
                                            onClick={() => this.onButtonClick('upload')} >
                                            <DV3BackIcon fillcolor={'#F72717'} />
                                            <FormattedMessage id='fines.goBack' defaultMessage='Go back' />
                                        </Link>
                                    </div>
                                    <Button
                                        loading={status.applying}
                                        onClick={this.onApply}
                                        disabled={currentFiles.length <= 0 || hasError || !results?.success || rowNumber <= 0}
                                        className='v3-button primary'
                                        style={{ minWidth: status.sendingFile ? '170px' : undefined }}>
                                        <FormattedMessage id='vehicles.upload.conclude' defaultMessage='Apply upload' />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Form>

            { (!!status.loading || !status.ready) && <LoadInWidget xtraClass={classes.loadingDiv} /> }
        </Fragment>
    }

}

UploadFineForm.contextType = HUBContext;
//UploadFineForm = Form.create({ name: 'upload_fine_form' })(UploadFineForm);
//UploadFineForm = withRouter(UploadFineForm);
export default withAlert()(withStyles(styles)(injectIntl(UploadFineForm)));